import { io } from 'socket.io-client';
import { getBaseApiUrl } from '../utils/urlUtils';
import { runtimeEnv } from '../config/runtimeEnv';

export const socket = io(getBaseApiUrl(), {
  path: runtimeEnv.wsPath,
  transports: ['websocket', 'polling'],
  autoConnect: false,
});
